<template>
    <div>
        <div v-if="data.message">
            <h2 class="text-center thank-you-heading">Welcome</h2>
            <p
                class="text-center paragraph"
                style="padding: 0px icon-customer-profil30px"
            >
                {{ data.message }}
            </p>
        </div>
        <div v-else>
            <h2 class="text-center thank-you-heading">Welcome Back, {{data.name}}!</h2>
            <p
                class="text-center paragraph"
                style="padding: 0px icon-customer-profil30px"
            >
                Your account draft was saved for
            </p>
            <ul class="row" style="list-style: none;">
                <li class="col-md-6">
                    <label>ID Number:</label>
                </li>
                <li class="col-md-6">
                    <span class="">{{ data.identityNumber }}</span>
                </li>
            </ul>
            <ul class="row" style="list-style: none;">
                <li class="col-md-6">
                    <label>Phone Number:</label>
                </li>
                <li class="col-md-6">
                    <span class="">{{ data.phoneNum }}</span>
                </li>
            </ul>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="row justify-content-center">
                    <base-button
                        btn-type="submit"
                        btn-variant="primary"
                        btn-label="CONTINUE"
                        :class="loading ? 'disabled' : ''"
                        :disabled="loading"
                        @click="onClick()"
                    >
                    </base-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import request from '@/utils/request'
import PopupButton from '@/components/registration/PopupButton.vue'
import { mapGetters } from 'vuex'

export default {
    components: {
        PopupButton,
    },

    props: {
        data: { type: Object },
    },

    data() {
        return {}
    },
    /*
  |--------------------------------------------------------------------------
  | Component > computed
  |--------------------------------------------------------------------------
  */
    computed: {
        // ...mapState({
        //     userOcr: (state) => state.registration.useOcr,
        // }),

        ...mapGetters(['dataSegmentId', 'loading', 'form']),

        dataSegmentId() {
            if (this.$route.params.dataSegmentId) {
                return this.$route.params.dataSegmentId
            }
            return this.$store.getters.dataSegmentId
        },
    },
    /*
  |--------------------------------------------------------------------------
  | Component > mounted
  |--------------------------------------------------------------------------
  */

    mounted() {},
    methods: {
        onClick() {
            this.$store.commit('setLoading', true)
            this.$emit('agreed')
        },
    },
}
</script>
<style scoped>
p {
    margin: 0;
    font-size: 16px;
    padding: 0px 20px;
}
.icon-tick-with-circle {
    color: green;
    font-size: 30px;
    cursor: pointer;
}
</style>
